import { render } from "./NameComponent.vue?vue&type=template&id=7523182f&scoped=true"
import script from "./NameComponent.vue?vue&type=script&lang=js"
export * from "./NameComponent.vue?vue&type=script&lang=js"

import "./NameComponent.vue?vue&type=style&index=0&id=7523182f&scoped=true&lang=css"

import exportComponent from "/home/islam/works/billing-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7523182f"]])

export default __exports__